import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/components/ui/badge";
import type { PropertyStatus } from "./types";
import { propertyStatusLabelKey, propertyStatusVariant } from "./format-property";

interface PropertyStatusBadgeProps {
  readonly status: PropertyStatus;
}

export function PropertyStatusBadge({ status }: PropertyStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge data-testid={`property-status-${status}`} variant={propertyStatusVariant(status)}>
      {t(propertyStatusLabelKey(status))}
    </Badge>
  );
}
